import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("iphix_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setToken = (t) => localStorage.setItem("iphix_token", t);
export const clearToken = () => localStorage.removeItem("iphix_token");

export const WA_NUMBER = "3908118913768";
export const STORE = { brand: "IPHIX 2.0", name: "iPhix Scafati", city: "Scafati (SA)",
  address: "Via Martiri d'Ungheria 123, 84018 Scafati (SA)",
  phone: "081 18913768", email: "iphixscafati@gmail.com" };

export const AVAILABILITY_META = {
  IN_NEGOZIO: { label: "In Negozio", hint: "Pronta consegna", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30", dot: "bg-emerald-400" },
  ORDINABILE: { label: "Ordinabile", hint: "Su ordinazione", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30", dot: "bg-blue-400" },
  DA_VERIFICARE: { label: "Da Verificare", hint: "Disponibilità da confermare", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30", dot: "bg-amber-400" },
  RISERVATO: { label: "Riservato", hint: "Riservato in negozio", cls: "bg-purple-500/15 text-purple-400 border-purple-500/30", dot: "bg-purple-400" },
  ESAURITO: { label: "Esaurito", hint: "Non disponibile", cls: "bg-rose-500/15 text-rose-400 border-rose-500/30", dot: "bg-rose-400" },
  VENDUTO: { label: "Venduto", hint: "Venduto", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30", dot: "bg-zinc-400" },
};
export const CONDITION_META = {
  NUOVO: { label: "Nuovo", cls: "bg-white/10 text-zinc-200 border-white/15" },
  RICONDIZIONATO: { label: "Ricondizionato", cls: "bg-cyan-500/10 text-cyan-300 border-cyan-500/25" },
  USATO: { label: "Usato", cls: "bg-orange-500/10 text-orange-300 border-orange-500/25" },
};
export const REPAIR_STATUS_META = {
  NUOVA_RICHIESTA: { label: "Nuova Richiesta", cls: "bg-blue-500/15 text-blue-400" },
  DA_VERIFICARE: { label: "Da Verificare", cls: "bg-amber-500/15 text-amber-400" },
  IN_ATTESA_RICAMBIO: { label: "Attesa Ricambio", cls: "bg-orange-500/15 text-orange-400" },
  DA_CONFERMARE: { label: "Da Confermare", cls: "bg-purple-500/15 text-purple-400" },
  CONFERMATA: { label: "Confermata", cls: "bg-emerald-500/15 text-emerald-400" },
  COMPLETATA: { label: "Completata", cls: "bg-teal-500/15 text-teal-400" },
  ANNULLATA: { label: "Annullata", cls: "bg-rose-500/15 text-rose-400" },
  NON_DISPONIBILE: { label: "Non Disponibile", cls: "bg-zinc-500/15 text-zinc-400" },
};

export const euro = (c) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format((c || 0) / 100);
export const waLink = (text) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
export const mapsLink = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent("iPhix Scafati, Via Martiri d'Ungheria 123, 84018 Scafati (SA), Italia")}`;

// Storefront
export const fetchMeta = async () => (await api.get("/meta")).data;
export const fetchCategories = async () => (await api.get("/categories")).data;
export const fetchBrands = async () => (await api.get("/brands")).data;
export const fetchProducts = async (params) => (await api.get("/products", { params })).data;
export const fetchProduct = async (slug) => (await api.get(`/products/${slug}`)).data;
export const fetchOffers = async () => (await api.get("/offers")).data;
export const mediaUrl = (p) => !p ? p : (p.startsWith("http") ? p : `${BACKEND_URL}${p}`);
export const adminOffers = async () => (await api.get("/admin/offers")).data;
export const createOffer = async (b) => (await api.post("/admin/offers", b)).data;
export const updateOffer = async (id, b) => (await api.put(`/admin/offers/${id}`, b)).data;
export const deleteOffer = async (id) => (await api.delete(`/admin/offers/${id}`)).data;
export const reorderOffers = async (ids) => (await api.post("/admin/offers/reorder", { ids })).data;
export const importOffer = async (url) => (await api.post("/admin/offers/import", { url })).data;
export const uploadOfferImage = async (image_base64) => (await api.post("/admin/offers/upload-image", { image_base64 })).data;
export const openAssistant = () => window.dispatchEvent(new Event("iphix:open-ai"));
// Riparazioni
export const fetchRepairsConfig = async () => (await api.get("/repairs/config")).data;
export const fetchRepairAvailability = async (date) => (await api.get("/repairs/availability", { params: { date } })).data;
export const submitRepairRequest = async (payload) => (await api.post("/repairs/requests", payload)).data;
// Auth
export const authLogin = async (email, password) => (await api.post("/auth/login", { email, password })).data;
export const authMe = async () => (await api.get("/auth/me")).data;
// Admin / Staff
export const fetchDashboard = async () => (await api.get("/admin/dashboard")).data;
export const staffRepairs = async (params) => (await api.get("/staff/repairs", { params })).data;
export const patchRepair = async (id, body) => (await api.patch(`/staff/repairs/${id}`, body)).data;
export const pricingSimulate = async (body) => (await api.post("/admin/pricing/simulate", body)).data;
export const pricingConfig = async () => (await api.get("/admin/pricing/config")).data;
export const putPricingConfig = async (body) => (await api.put("/admin/pricing/config", body)).data;
export const pricingRules = async () => (await api.get("/admin/pricing/rules")).data;
export const createPricingRule = async (body) => (await api.post("/admin/pricing/rules", body)).data;
export const updatePricingRule = async (rid, body) => (await api.put(`/admin/pricing/rules/${rid}`, body)).data;
export const deletePricingRule = async (rid) => (await api.delete(`/admin/pricing/rules/${rid}`)).data;
export const recalcPrices = async (body = {}) => (await api.post("/admin/pricing/recalculate", body)).data;
export const pricingTargets = async () => (await api.get("/admin/pricing/targets")).data;
export const setProductPrice = async (body) => (await api.post("/admin/pricing/product-price", body)).data;
export const lockedProducts = async () => (await api.get("/admin/pricing/locked-products")).data;
export const listImports = async () => (await api.get("/admin/imports")).data;
export const createImport = async (body) => (await api.post("/admin/imports", body)).data;
export const inventoryList = async (q) => (await api.get("/staff/inventory", { params: { q } })).data;
export const inventoryMovement = async (body) => (await api.post("/staff/inventory/movement", body)).data;
// Assistente AI (Fase 10)
export const aiStatus = async () => (await api.get("/ai/status")).data;
export const aiChat = async (session_id, message) => (await api.post("/ai/chat", { session_id, message })).data;
export const aiGetConfig = async () => (await api.get("/admin/ai/config")).data;
export const aiPutConfig = async (body) => (await api.put("/admin/ai/config", body)).data;
export const aiUsage = async () => (await api.get("/admin/ai/usage")).data;
export const aiConversations = async () => (await api.get("/admin/ai/conversations")).data;

export const aiSessionId = () => {
  let s = localStorage.getItem("iphix_ai_session");
  if (!s) { s = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random())); localStorage.setItem("iphix_ai_session", s); }
  return s;
};

// ---- Analytics + tracking (Blocco C) ----
export const visitorId = () => {
  let s = localStorage.getItem("iphix_visitor");
  if (!s) { s = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now() + Math.random())); localStorage.setItem("iphix_visitor", s); }
  return s;
};
export const captureUtm = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const src = p.get("utm_source"), med = p.get("utm_medium"), camp = p.get("utm_campaign");
    if (src || med || camp) localStorage.setItem("iphix_utm", JSON.stringify({ src, med, camp }));
  } catch { /* noop */ }
};
export const track = async (event, meta = {}) => {
  try {
    const u = JSON.parse(localStorage.getItem("iphix_utm") || "{}");
    await api.post("/track", { event, session_id: visitorId(), path: window.location.pathname,
      utm_source: u.src || null, utm_medium: u.med || null, utm_campaign: u.camp || null, meta });
  } catch { /* noop */ }
};
export const adminAnalytics = async (days = 30) => (await api.get("/admin/analytics", { params: { days } })).data;
// ---- Volantini AI (Blocco D) ----
export const listFlyers = async () => (await api.get("/admin/flyers")).data;
export const createFlyer = async (body) => (await api.post("/admin/flyers", body)).data;
export const getFlyer = async (id) => (await api.get(`/admin/flyers/${id}`)).data;
export const applyFlyer = async (id, body) => (await api.post(`/admin/flyers/${id}/apply`, body)).data;
export const deleteFlyer = async (id) => (await api.delete(`/admin/flyers/${id}`)).data;
// ---- Copilot admin (Task 1) ----
export const copilotChat = async (session_id, message) => (await api.post("/admin/copilot/chat", { session_id, message })).data;
export const copilotUploadFiles = async (session_id, files) => {
  const fd = new FormData();
  fd.append("session_id", session_id);
  files.forEach((f) => fd.append("files", f));
  return (await api.post("/admin/copilot/attachments", fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const copilotListFiles = async (session_id) => (await api.get(`/admin/copilot/attachments?session_id=${encodeURIComponent(session_id)}`)).data;
// Copilot Promo Intelligence (locandine -> proposte prezzo)
export const analyzePromos = async (offer_id) => (await api.post("/admin/copilot/promos/analyze", offer_id ? { offer_id } : {})).data;
export const listPromoProposals = async () => (await api.get("/admin/copilot/promos")).data;
export const approvePromo = async (id, body) => (await api.post(`/admin/copilot/promos/${id}/approve`, body || {})).data;
export const rejectPromo = async (id) => (await api.post(`/admin/copilot/promos/${id}/reject`)).data;
export const updatePromoProposal = async (id, body) => (await api.put(`/admin/copilot/promos/${id}`, body)).data;
export const priceHistory = async () => (await api.get("/admin/price-history")).data;
export const expiringPromos = async (hours = 48) => (await api.get("/admin/promos/expiring", { params: { hours } })).data;

// Listini / Pubblicazione (Fase 5b)
export const listPriceLists = async () => (await api.get("/admin/price-lists")).data;
export const getImport = async (jid) => (await api.get(`/admin/imports/${jid}`)).data;
export const approveImport = async (jid, body) => (await api.post(`/admin/imports/${jid}/approve`, body)).data;
export const createPriceList = async (id, b) => (await api.post(`/admin/suppliers/${id}/price-lists`, b)).data;
export const publishImport = async (jid) => (await api.post(`/admin/imports/${jid}/publish`)).data;
export const listSuppliers = async () => (await api.get("/admin/suppliers")).data;
export const createSupplier = async (b) => (await api.post("/admin/suppliers", b)).data;
export const updateSupplier = async (id, b) => (await api.put(`/admin/suppliers/${id}`, b)).data;
export const supplierDetail = async (id) => (await api.get(`/admin/suppliers/${id}`)).data;
export const uploadPriceListFile = async (lid, body) => (await api.post(`/admin/suppliers/price-lists/${lid}/upload`, body)).data;
export const analyzePriceList = async (lid) => (await api.post(`/admin/suppliers/price-lists/${lid}/analyze`)).data;
export const priceListRows = async (lid, params) => (await api.get(`/admin/suppliers/price-lists/${lid}/rows`, { params })).data;
export const priceListFileUrl = (lid) => `${API}/admin/suppliers/price-lists/${lid}/file`;
export const newListVersion = async (lid, body) => (await api.post(`/admin/suppliers/price-lists/${lid}/new-version`, body || {})).data;
export const autoUpdatePriceList = async (sid, body) => (await api.post(`/admin/suppliers/${sid}/price-lists/auto-update`, body)).data;
export const restorePriceList = async (lid) => (await api.post(`/admin/suppliers/price-lists/${lid}/restore`)).data;
export const nwgReplaceList = async (body) => (await api.post(`/admin/nwg/replace-list`, body)).data;
export const nwgRestoreList = async (lid) => (await api.post(`/admin/nwg/restore-list/${lid}`)).data;
export const legacyBackfill = async () => (await api.post(`/admin/suppliers/legacy-backfill`)).data;

export const nwgStats = async () => (await api.get("/admin/nwg/stats")).data;
export const nwgParts = async (params) => (await api.get("/admin/nwg/parts", { params })).data;
export const nwgReimport = async () => (await api.post("/admin/nwg/import")).data;
export const buildDiff = async (lid) => (await api.post(`/admin/suppliers/price-lists/${lid}/diff`)).data;
export const getDiff = async (lid, params) => (await api.get(`/admin/suppliers/price-lists/${lid}/diff`, { params })).data;
export const diffItemDecision = async (id, decision) => (await api.post(`/admin/diff-items/${id}/decision`, { decision })).data;
export const diffBulk = async (diffId, body) => (await api.post(`/admin/diffs/${diffId}/bulk`, body)).data;
export const applyPreview = async (diffId) => (await api.post(`/admin/diffs/${diffId}/apply/preview`)).data;
export const applyDiff = async (diffId) => (await api.post(`/admin/diffs/${diffId}/apply`)).data;
export const listApplyBatches = async (sid) => (await api.get(`/admin/suppliers/${sid}/apply-batches`)).data;
export const getApplyBatch = async (bid) => (await api.get(`/admin/apply-batches/${bid}`)).data;
export const rollbackBatch = async (bid) => (await api.post(`/admin/apply-batches/${bid}/rollback`)).data;
export const supplierDiffs = async (sid) => (await api.get(`/admin/suppliers/${sid}/diffs`)).data;
export const searchListItems = async (params) => (await api.get(`/admin/supplier-list-items/search`, { params })).data;
export const compareListItems = async (params) => (await api.get(`/admin/supplier-list-items/compare`, { params })).data;
export const rollbackItem = async (logId) => (await api.post(`/admin/apply-log/${logId}/rollback`)).data;
// Utenti staff/manager
export const listUsers = async () => (await api.get("/admin/users")).data;
export const createUser = async (body) => (await api.post("/admin/users", body)).data;
export const deleteUser = async (id) => (await api.delete(`/admin/users/${id}`)).data;
// Catalogo / Immagini (F7)
export const adminCatalog = async (params) => (await api.get("/admin/catalog", { params })).data;
export const fetchCatalogImages = async () => (await api.post("/admin/catalog/fetch-images")).data;
export const productImages = async (pid) => (await api.get(`/admin/products/${pid}/images`)).data;
export const searchImages = async (pid) => (await api.post(`/admin/products/${pid}/images/search`)).data;
export const addImage = async (pid, url) => (await api.post(`/admin/products/${pid}/images`, { url })).data;
export const approveImage = async (iid) => (await api.post(`/admin/product-images/${iid}/approve`)).data;
export const rejectImage = async (iid) => (await api.delete(`/admin/product-images/${iid}`)).data;
// CRM (Fase 11)
export const crmMeta = async () => (await api.get("/admin/crm/meta")).data;
export const listLeads = async (params) => (await api.get("/admin/leads", { params })).data;
export const createLead = async (body) => (await api.post("/admin/leads", body)).data;
export const patchLead = async (id, body) => (await api.patch(`/admin/leads/${id}`, body)).data;
export const waConfig = async () => (await api.get("/admin/whatsapp/config")).data;
export const putWaConfig = async (body) => (await api.put("/admin/whatsapp/config", body)).data;
// Ordini (Fase 12)
export const createOrder = async (body) => (await api.post("/orders", body)).data;
export const orderStatus = async (num, email) => (await api.get(`/orders/${num}`, { params: email ? { email } : {} })).data;
export const adminOrders = async (params) => (await api.get("/admin/orders", { params })).data;
export const patchOrder = async (id, body) => (await api.patch(`/admin/orders/${id}`, body)).data;
export const bankConfig = async () => (await api.get("/admin/bank-config")).data;
export const putBankConfig = async (body) => (await api.put("/admin/bank-config", body)).data;
// Spedizioni (Fase 13) + Provider prezzi (Fase 14)
export const shipmentUpdate = async (oid, body) => (await api.patch(`/admin/orders/${oid}/shipment`, body)).data;
export const shippingConfig = async () => (await api.get("/admin/shipping/config")).data;
export const putShippingConfig = async (b) => (await api.put("/admin/shipping/config", b)).data;
export const ppConfig = async () => (await api.get("/admin/price-provider/config")).data;
export const putPpConfig = async (b) => (await api.put("/admin/price-provider/config", b)).data;
export const SHIPMENT_STATUSES = ["DA_PREPARARE", "PRONTO", "AFFIDATO_CORRIERE", "IN_TRANSITO", "CONSEGNATO", "PROBLEMA"];
export const SHIPMENT_META = { DA_PREPARARE: "Da preparare", PRONTO: "Pronto", AFFIDATO_CORRIERE: "Affidato al corriere", IN_TRANSITO: "In transito", CONSEGNATO: "Consegnato", PROBLEMA: "Problema" };

// ===== USATO IPHIX (FASE 1) =====
export const USED_STATUSES = ["DISPONIBILE", "RISERVATO", "IN_VERIFICA", "VENDUTO"];
export const USED_STATUS_META = {
  DISPONIBILE: { label: "Disponibile", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30", pub: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  RISERVATO: { label: "Riservato", cls: "bg-purple-500/15 text-purple-400 border-purple-500/30", pub: "bg-purple-100 text-purple-700 border-purple-200" },
  IN_VERIFICA: { label: "In verifica", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30", pub: "bg-amber-100 text-amber-700 border-amber-200" },
  VENDUTO: { label: "Venduto", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30", pub: "bg-zinc-100 text-zinc-600 border-zinc-200" },
};
export const USED_PHOTO_CATEGORIES = [
  { code: "frontale", label: "Frontale" }, { code: "retro", label: "Retro" }, { code: "lati", label: "Lati" },
  { code: "sopra_sotto", label: "Sopra / Sotto" }, { code: "difetti", label: "Difetti" },
  { code: "batteria_diagnostica", label: "Batteria / Diagnostica" }, { code: "altro", label: "Altro" },
];
// Public
export const fetchUsato = async () => (await api.get("/usato")).data;
export const fetchUsatoDetail = async (id) => (await api.get(`/usato/${id}`)).data;
export const fetchUsatoGrades = async () => (await api.get("/usato/grades")).data;
export const fetchUsatoVetrina = async () => (await api.get("/usato/vetrina")).data;
export const usatoPrice = (d) => (d && d.promo_attiva ? d.promo_price_cents : (d ? d.prezzo_vendita_cents : 0));
// Admin
export const adminUsato = async (params) => (await api.get("/admin/usato", { params })).data;
export const adminUsatoGet = async (id) => (await api.get(`/admin/usato/${id}`)).data;
export const createUsato = async (b) => (await api.post("/admin/usato", b)).data;
export const updateUsato = async (id, b) => (await api.put(`/admin/usato/${id}`, b)).data;
export const patchUsatoStatus = async (id, stato) => (await api.patch(`/admin/usato/${id}/status`, { stato })).data;
export const deleteUsato = async (id) => (await api.delete(`/admin/usato/${id}`)).data;
export const usatoImages = async (id) => (await api.get(`/admin/usato/${id}/images`)).data;
export const addUsatoImage = async (id, b) => (await api.post(`/admin/usato/${id}/images`, b)).data;
export const delUsatoImage = async (id, iid) => (await api.delete(`/admin/usato/${id}/images/${iid}`)).data;
export const reorderUsatoImages = async (id, order) => (await api.put(`/admin/usato/${id}/images/reorder`, { order })).data;
export const adminUsatoGrades = async () => (await api.get("/admin/usato/config/grades")).data;
export const putUsatoGrades = async (grades) => (await api.put("/admin/usato/config/grades", { grades })).data;

export const ORDER_FLOW = ["CREATO", "ATTESA_BONIFICO", "PAGAMENTO_DA_VERIFICARE", "PAGATO", "PREPARAZIONE", "PRONTO_RITIRO", "DA_SPEDIRE", "SPEDITO", "CONSEGNATO", "ANNULLATO"];
export const ORDER_STATUS_META = {
  CREATO: "Creato", ATTESA_BONIFICO: "Attesa bonifico", PAGAMENTO_DA_VERIFICARE: "Pagamento da verificare",
  PAGATO: "Pagato", PREPARAZIONE: "In preparazione", PRONTO_RITIRO: "Pronto al ritiro",
  DA_SPEDIRE: "Da spedire", SPEDITO: "Spedito", CONSEGNATO: "Consegnato", ANNULLATO: "Annullato",
};
